<template>
  <myHaed />
  <div class="home" v-show="true">
    <div class="startlotto mybox">
      <!-- <p class="title">最新一期开奖</p> -->
    </div>
    <!-- 站点导航 -->
    <plan_nav />
    <zhandian :list="data2.slice(0, 8)" />
    <div class="content">
      <iframe
        class="kaijiangIfram"
        :style="`width: 100%; height: ${iframeHeight}px;margin-bottom:12px`"
        :src="`${kaijiangUrl}&myclassName=class2`"
        frameborder="0"
      ></iframe>
    </div>
  </div>
  <planVue />
  <imgsVue :list="imgdata.slice(0, 2)" />
  <plan _com="pingtewuma" />
  <zhandian :list="data2.slice(8, 12)" />
  <imgsVue :list="imgdata.slice(2, 4)" />
  <plan _com="dandaxiaoxiao" />
  <imgsVue :list="imgdata.slice(4, 6)" />
  <plan _com="riyexiao" />
  <imgsVue :list="imgdata.slice(3, 9)" />
  <plan _com="shujinguangsanxiao" />
  <imgsVue :list="imgdata.slice(0, 2)" />
  <plan _com="wuweibizhong" />
  <imgsVue :list="imgdata.slice(10, 11)" />
  <imgsVue :list="imgdata.slice(1, 2)" />
  <imgsVue :list="imgdata.slice(1, 2)" />
  <plan _com="biaozhunqiwei" />
  <zhandian :list="data2.slice(12, 20)" />
  <imgsVue :list="imgdata.slice(1, 2)" />
  <imgsVue :list="imgdata.slice(2, 3)" />
  <imgsVue :list="imgdata.slice(3, 4)" />
  <imgsVue :list="imgdata.slice(4, 5)" />
  <imgsVue :list="imgdata.slice(5, 6)" />
  <imgsVue :list="imgdata.slice(6, 7)" />
  <imgsVue :list="imgdata.slice(7, 2)" />
  <imgsVue :list="imgdata.slice(8, 9)" />
  <imgsVue :list="imgdata.slice(9, 10)" />
  <imgsVue :list="imgdata.slice(10, 11)" />
  <imgsVue :list="imgdata.slice(11, 12)" />
  <imgsVue :list="imgdata.slice(12, 13)" />
  <imgsVue :list="imgdata.slice(13, 14)" />
  <imgsVue :list="imgdata.slice(14, 15)" />
  <zhandian1 :l="12" />
  <imgsVue :list="imgdata.slice(1, 2)" />
  <imgsVue :list="imgdata.slice(1, 2)" />
  <imgsVue :list="imgdata.slice(1, 2)" />
  <imgsVue :list="imgdata.slice(1, 2)" />
  <typeTable />
</template>

<script setup>
import zhandian from "../components/zhandian.vue";
import zhandian1 from "../components/zhandian1.vue";
import plan from "../components/plan_new/plan.vue";
import planNav from "@/components/planNav.vue";
import daohang1 from "@/components/daohang1.vue";
import tukudaohang from "@/components/tukudaohang.vue";
import daohang from "@/components/daohang.vue";
import typeTable from "../components/propertyTable/table.vue";
import xianggang_shoulu from "@/components/xianggang_shoulu.vue";
import aomen_plan from "@/components/aomen_plan.vue";
import xianggang_tuku from "@/components/xianggang_tuku.vue";
import zhanwaishoulv from "@/components/zhanwaishoulv.vue";
import tuku from "@/components/tuku.vue";
import s1 from "@/assets/img/swipe/1.jpg";
import s2 from "@/assets/img/swipe/2.png";
import s3 from "@/assets/img/swipe/3.png";
import myHaed from "@/components/head.vue";
import startlottoNums from "@/components/startlottoNums.vue";
import plan_nav from "@/components/plan_nav.vue";
import aomen_shoulu from "@/components/aomen_shoulu.vue";
import myFooter from "@/components/myFooter.vue";
import { reactive, ref, nextTick } from "vue";
import imgsVue from "../components/imgs.vue";
import { imgdata, data2 } from "../utils/data";
import planVue from "../components/plan/plan.vue";
import { getKaijiangUrl } from "../utils";

const kaijiangUrl = ref("");
kaijiangUrl.value = getKaijiangUrl();

const iframeHeight = ref(200);
window.addEventListener("message", handleMessage);
function handleMessage(event) {
  const data = event.data;
  if (data && data.type === "resize" && typeof data.height === "number") {
    iframeHeight.value = data.height;
  }
}

const gif2 = "https://www.7859888tp.com/750-50.gif";
const gif3 = "https://5598tp.com/tp/8tyaizopc.gif";
const gif4 = "https://5598tp.com/tp/8tyaizopc.gif";
const gif5 = "https://8932888tp.com/tp/btyd.gif";
const gif6 = "https://9323tp.cc/tp/960x60.gif";

const notice = ref(
  "无论我们能活多久，我们能够享受的只有无法分割的此刻，此外别无其他。"
);
</script>

<style lang="scss" scoped>
.floating-bubble-logo {
  width: 100%;
  height: 100%;
  box-shadow: 2px 2px 10px 0px #000;
}
.home {
  background-color: #fff;
}
::v-deep .van-notice-bar {
  height: 35px;
  line-height: 35px;
  div {
    font-size: 12px;
    height: 35px;
    line-height: 35px;
  }
}
::v-deep .my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 100px;
  text-align: center;
  background-color: #39a9ed;
  .van-image__img {
    height: 100px;
    width: 100vw;
  }
}
.colorRed {
  color: red;
}
.startlotto {
  background-color: #fff;
  .title {
    font-weight: bold;
    text-align: center;
    background-color: #eee;
  }
}
.iframeBox {
  width: 100vw;
  overflow: hidden;
  position: relative;
}
</style>